"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedFilterItem = void 0;
const react_1 = __importStar(require("react"));
const AdvancedFilterDataSelectorIds_1 = require("../../helpers/AdvancedFilterDataSelectorIds");
const controls_1 = require("../../../controls");
const Icon_1 = require("../../../Icon");
const AdvancedFilterItem_styles_1 = require("./AdvancedFilterItem.styles");
exports.AdvancedFilterItem = (0, react_1.memo)(({ iconSrc, checked, onChange, label, testId }) => {
    return (react_1.default.createElement(AdvancedFilterItem_styles_1.StyledAdvancedFilterItem, null,
        react_1.default.createElement(controls_1.Checkbox, { onChange: onChange, "data-selector-id": testId || AdvancedFilterDataSelectorIds_1.AdvancedFilterDataSelectorIds.checkbox, checked: checked },
            react_1.default.createElement(AdvancedFilterItem_styles_1.StyledAdvancedFilterItemLabel, null,
                iconSrc && react_1.default.createElement(Icon_1.Icon, { src: iconSrc }),
                react_1.default.createElement("span", null, label)))));
});
exports.AdvancedFilterItem.displayName = 'AdvancedFilterItem';
//# sourceMappingURL=AdvancedFilterItem.js.map